// Query for the caller's pinned groups (sidebar "Pinned" section).
//
// Mirrors the previous server-side `listMyPins` helper but as a client
// TanStack Query — same network call, same return shape, just no
// React-cache wrapper (TanStack's `queryKey` cache replaces it).

import { queryOptions, useQuery } from '@tanstack/react-query';
import type { components } from '@leanin/api-client';
import { getApiClient } from '@/lib/api-client';

export type PinnedGroupKind = components['schemas']['PinnedGroup']['kind'];
export type PinnedGroup = components['schemas']['PinnedGroup'];

export const pinsKeys = {
  all: ['pins'] as const,
  list: () => [...pinsKeys.all, 'list'] as const,
};

export const myPinsQuery = queryOptions({
  queryKey: pinsKeys.list(),
  queryFn: async (): Promise<readonly PinnedGroup[]> => {
    const client = getApiClient();
    const { data, response } = await client.GET('/api/v1/pins', {});
    if (!response.ok || data === undefined) return [];
    return data.items;
  },
  staleTime: 60_000,
});

export function useMyPins(options?: { enabled?: boolean }) {
  return useQuery({ ...myPinsQuery, ...options });
}
